import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { ISlideComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/slide/types';
import { IObservableArray } from 'mobx';

// 调用slide组件的入口
export enum SLIDE_RENDER_ENTRY {
    EDIT_PC = 'edit-pc', // 编辑区-PC端
    EDIT_MOBILE = 'edit-mobile', // 编辑区-移动端
    THUMBNAIL_PC = 'thumbnail-pc', // 列表-PC端
    THUMBNAIL_MOBILE = 'thumbnail-mobile', // 列表-移动端
    PLAYER_EDIT_PC = 'player-edit-pc', // 演示-编辑区-PC端
    PLAYER_EDIT_MOBILE = 'player-edit-mobile', // 演示-编辑区-移动端
    PLAYER_THUMBNAIL_PC = 'player-thumbnail-pc', // 演示-列表-PC端
    PLAYER_THUMBNAIL_MOBILE = 'player-thumbnail-mobile', // 演示-列表-移动端
    UNKNOWN = 'unknown' // 未知
}

// 注入的service
export interface ISlideRenderStateServices {
    selectionService: ISelectionService;
    uiDataService: IUiDataService
}

// 不同入口的slide 渲染耗时记录map的key规则
export type IEntrySlideRenderCostKey = `${string}-${SLIDE_RENDER_ENTRY}`;

// 渲染完成结果
export interface IStatePointResult {
    time: number,
    entry: SLIDE_RENDER_ENTRY
}

// 编辑区渲染完成结果(指定slide)
export type IEditStatePointResult = IStatePointResult & {
    slide: ISlideModel;
};

// 首次渲染完成时的信息
export interface firstRenderCompleteInfo {
    firstTime?: number,
    promise?: Promise<IStatePointResult>,
    resolve?: (val: IStatePointResult) => void;
}

// 包含首次以及最新一次的渲染完成信息
export type renderCompleteInfo = firstRenderCompleteInfo & { latestTime?: number };

// 状态时机基类
export interface IBaseStatePoint {
    isCompleted: boolean;
    getPointCompletePromise(): Promise<IStatePointResult>;
}

// 状态时机扩展类
export interface IStatePoint extends IBaseStatePoint {
    emitPointComplete(params: IStatePointResult): boolean;
}

// 状态时机(编辑区)
export interface IEditStatePoint {
    emitPointComplete(params: IEditStatePointResult): void;
    getEditSlideRenderCompletePromiseByModel(slide: ISlideModel): Promise<IStatePointResult>;
    resetEditSlideRenderCompletePromise(slide: ISlideModel): Promise<void>;
}

// 各状态时机枚举
export enum IStatePointEnum {
    firstSlideRender = 'firstSlideRender',
    allThumbnailSite = 'allThumbnailSite',
    visibleSlideRender = 'visibleSlideRender',
    allSlideConvert = 'allSlideConvert',
    editSlideRender = 'editSlideRender',
}

export interface IStatePointCollection {
    [IStatePointEnum.firstSlideRender]: IStatePoint,
    [IStatePointEnum.allThumbnailSite]: IStatePoint,
    [IStatePointEnum.visibleSlideRender]: IStatePoint,
    [IStatePointEnum.allSlideConvert]: IStatePoint,
    [IStatePointEnum.editSlideRender]: IEditStatePoint,
}

// 渲染状态服务
export interface ISlideRenderStateManager {
    setServicesDelegate(params: ISlideRenderStateServices): void;
    getServicesPromise(): Promise<ISlideRenderStateServices>;

    /**
     * 记录文档页数
     * @param size
     */
    setPageSize(size: number): void;

    /**
     * 标记当前文档的缩略图已构建，并记录缩略图个数
     */
    setListPanelSize(size: number, entry: SLIDE_RENDER_ENTRY): void;

    /**
     * 添加露出的slide
     * @param slide
     */
    addVisibleSlide(slide: ISlideModel): void;

    /**
     * 移除露出的slide
     * @param slide
     */
    removeVisibleSlide(slide: string): void;

    /**
     * 记录此slideComponent的渲染完成时间
     * @param slideComponent
     * @param entry
     */
    setSlideRenderCompleted(slideComponent: ISlideComponent, entry: SLIDE_RENDER_ENTRY): void;

    /**
     * 获取各渲染时机的集合
     */
    getStatePoints(): IStatePointCollection;

    /**
     * 获取文档页数
     */
    getPageSize(): number | undefined;

    /**
     * 获取缩略图渲染时间列表
     */
    getListCellFirstLoadTimeArr(): number[]

    /**
     * 获取可见slide key集合
     */
    getVisibleSlideKeyList(): IObservableArray<string>
}
